import clsx from "clsx";
import { SearchIcon } from "lucide-react";
import { useMemo } from "react";

import { useGlobalStore } from "~/hooks";
import { getPlatformControlKey } from "~/utils/helpers";

const SearchButton = ({ isInverted }: { isInverted?: boolean }) => {
	const { toggleSearchModal } = useGlobalStore();

	const controlKey = useMemo(() => getPlatformControlKey(), []);

	return (
		<button
			suppressHydrationWarning
			onClick={toggleSearchModal}
			onKeyDown={(e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					toggleSearchModal();
				}
			}}
			data-tooltip-id="tooltip"
			data-tooltip-content={`${controlKey} + K to search`}
			aria-label={`Search (${controlKey} + K)`}
			className={clsx(
				"flex h-10 w-10 cursor-pointer select-none items-center justify-center rounded-full text-2xl transition-colors duration-200 hover:bg-slate-100 focus:bg-slate-100 focus:outline-none dark:focus:bg-slate-700 dark:hover:bg-slate-700",
				{ "text-white hover:bg-slate-700/50 focus:bg-slate-700": isInverted },
			)}
		>
			<SearchIcon size={24} aria-hidden="true" />
		</button>
	);
};

export default SearchButton;
